var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('img',{attrs:{"id":"simbol","src":_vm.image}}),_c('span',{staticClass:"title",class:{
            disabled: _vm.disabled,
          }},[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"id":"icon","src":require("../assets/images/icons/next.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }